import * as React from 'react';
import { useState, useEffect, forwardRef } from 'react';

/** Material UI Packages. */
import { Slide, Dialog, Box, Tabs, Tab, Tooltip } from '@mui/material';

/** Material UI Icons. */
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import AppRegistrationIcon from '@mui/icons-material/AppRegistration';

/** Internal Components. */
import DialogHeader from '../../components/DialogHeader';
import CustomSnackbar from '../../components/CustomSnackbar';

import AccountInfo from './AccountInfo';
import TPSharing from './TPSharing';
import AddOns from './AddOns';

/**  Showing dialog effect  */
const Transition = forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const TABS = [
    { label: 'Account Info', icon: <SettingsSuggestIcon /> },
    { label: 'TP Sharing', icon: <GroupAddIcon /> },
    { label: 'Addons', icon: <AppRegistrationIcon /> },
];

export default function AccountDialog(props) {
    /** Get props from Account.js. */
    const { acctRows, setAcctRows, accountDialogOpen, setAccountDialogOpen, selectedId } = props;

    /** State for the tab value. */
    const [value, setValue] = useState(0);

    /** Handle to remind save and close a dialog for references. */
    const handleClose = () => {
        setAccountDialogOpen(false);
        setValue(0);
    };

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Dialog
            fullScreen
            open={accountDialogOpen}
            onClose={handleClose}
            slots={{
                transition: Transition,
            }}
        >
            <DialogHeader cursor title={'Account Setting'} onClose={handleClose} />
            <Box sx={{ display: 'flex', height: 'calc(100vh - 64px)' }}>
                <Tabs
                    orientation="vertical"
                    value={value}
                    onChange={handleChange}
                    sx={{
                        borderRight: 1,
                        borderColor: 'divider',
                        width: 70,
                        '& .MuiTab-root': {
                            minHeight: 70,
                            minWidth: 0,
                            p: 0,
                        },
                        '& .Mui-selected': {
                            backgroundColor: '#e3f2fd',
                            color: '#1976d2',
                        },
                    }}
                >
                    {TABS.map((tab, index) => (
                        <Tooltip key={index} title={tab.label} placement="right">
                            <Tab icon={tab.icon} />
                        </Tooltip>
                    ))}
                </Tabs>

                <Box sx={{ flex: 1, overflow: 'auto' }}>
                    {value === 0 && <AccountInfo acctRows={acctRows} selectedId={selectedId} />}
                    {value === 1 && <TPSharing acctRows={acctRows} setAcctRows={setAcctRows} selectedId={selectedId} />}
                    {value === 2 && <AddOns acctRows={acctRows} setAcctRows={setAcctRows} selectedId={selectedId} />}
                </Box>
                <CustomSnackbar />
            </Box>
        </Dialog>
    );
}
